import { graphqlCall } from '@pella/fetch-client';
import * as queries from './ebsMfgApi.graphql.js';

const GRAPHQL_URL = `${window.REACT_APP_API_URL}/ebs-mfg/graphql`;

/**
 * Get an inventory item ID that has quantity on hand > 0 for the given organization.
 * @param {number} organizationId - The organization ID to search within
 * @returns {Promise<number>} - The inventory item ID
 */
export const getInventoryItemIdWithQtyOnHand = async (organizationId) => {
  const { data } = await graphqlCall(GRAPHQL_URL, queries.GET_INVENTORY_ITEM_WITH_QTY_ON_HAND, {
    input: { organizationId },
  });
  return data.getInventoryItemIdWithQtyOnHand.inventoryItemId;
};

/**
 * Get parts description.
 * @param {Local.GetPartsDescriptionInput} variables
 * @returns {Promise<Local.GetPartsDescriptionOutput>}
 */
export const getPartsDescription = async ({ partNumber }) => {
  const { data } = await graphqlCall(GRAPHQL_URL, queries.GET_PARTS_DESCRIPTION, { partNumber });
  return data.getPartsDescription;
};
/**
 * Get lumber location by item.
 * @param {Local.GetLumberLocationByItemInput} variables
 * @returns {Promise<Local.GetLumberLocationByItemOutput>}
 */
export const getLumberLocationByItem = async ({ itemNumber }) => {
  const { data } = await graphqlCall(GRAPHQL_URL, queries.GET_LUMBER_LOCATION_BY_ITEM, { itemNumber });
  return data.getLumberLocationByItem;
};
/**
 * Get die and description.
 * @param {Local.GetDieAndDescriptionInput} variables
 * @returns {Promise<Local.GetDieAndDescriptionOutput>}
 */
export const getDieAndDescription = async ({ organizationId, item }) => {
  const { data } = await graphqlCall(GRAPHQL_URL, queries.GET_DIE_AND_DESCRIPTION, { organizationId, item });
  return data.getDieAndDescription;
};
/**
 * Get lumber item info by schedule.
 * @param {Local.LumberItemInfoByScheduleInput} variables
 * @returns {Promise<Local.LumberItemInfoByScheduleOutput>}
 */
export const getLumberItemInfoBySchedule = async ({ scheduleNumber }) => {
  const { data } = await graphqlCall(GRAPHQL_URL, queries.GET_LUMBER_ITEM_INFO_BY_SCHEDULE, { scheduleNumber });
  return data.getLumberItemInfoBySchedule;
};
/**
 * Get put down mill lookup by item.
 * @param {Local.PutDownMillLookupInput} variables
 * @returns {Promise<Local.PutDownMillLookupOutput>}
 */
export const getPutDownMillLookupByItem = async ({ item }) => {
  const { data } = await graphqlCall(GRAPHQL_URL, queries.GET_PUT_DOWN_MILL_LOOKUP_BY_ITEM, { item });
  return data.getPutDownMillLookupByItem;
};
